import { useEffect, useState } from "react";
import { breadcrumbState } from "../../../lib/stores/breadcrumb";
import { useRecoilState } from "recoil";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { get, post, put } from "../../../services/apiService";
import getApiEndpoints from "../../../services/endpoints";
import {
  Form,
  // Input,
  Button,
  message,
  Select,
  // Checkbox,
  notification,
  Row,
  Col,
} from "antd";
import FormBuilder from "antd-form-builder";
import {
  emailValidator,
  latitudeValidator,
  longitudeValidator,
} from "../../../lib/utils/form-validator";
import { companyState } from "../../../lib/stores/companyId";
import "./page.css";

const MachinesForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log(location?.pathname, "location");

  const [, setBreadCrumb] = useRecoilState(breadcrumbState);
  const { id } = useParams();
  const [form] = Form.useForm();
  const [companyId] = useRecoilState(companyState);
  const [companyDropdown, setCompanyDropdown] = useState<any>([]);
  const user: any =
    localStorage.getItem("user") || sessionStorage.getItem("user");
  const userDataNew: any = JSON.parse(user);
  const userRole: any = userDataNew?.roles[0];
  const apiEndpoints: any = getApiEndpoints(userRole);
  // const [companyTypes, setCompanyTypes] = useState([]);
  const [statesDropdown, setStatesDropdown] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [locationsDropdown, setLocationsDropdown] = useState([]);
  const [machineTypesDropdown, setMachineTypesDropdown] = useState([]);

  useEffect(() => {
    setBreadCrumb([
      { label: "Masters", href: "/dashboard" },
      { label: "Machines", href: "/machines" },
      {
        label: id ? "Edit Machine" : "Add Machine",
        href: id ? `/machines/${id}` : "/machines/add",
      },
    ]);
  }, [setBreadCrumb]);

  // const fetchEditData = async (item) => {
  //   const payLoad = {
  //     deviceId: item.deviceId,
  //     companyId: item.companyId,
  //   };
  //   try {
  //     const editResponse = await post(apiEndpoints.getByDeviceId, payLoad);
  //     if (editResponse.status === 200) {
  //       setTimeout(() => {
  //         setEditData((prev) => ({ ...prev, ...editResponse?.data }));
  //       }, 1000);
  //     }
  //   } catch (error) {
  //     console.log(error, "error");
  //   }
  // };

  const fetchById = async () => {
    try {
      const payLoad = {
        companyId: id,
      };
      // replace endpoint with location id endpoint to get details
      const response = await post(apiEndpoints.getCompanyMasterId, payLoad);
      if (response.status === 200) {
        const initialValues = {
          ...response?.data,
          active: response?.data?.isActive === 1 ? true : false,
        };
        form.setFieldsValue(initialValues);
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    if (location.pathname.includes("editCompany")) {
      fetchById();
    }
  }, [location]);

  useEffect(() => {
    handleData();
  }, []);

  const handleData = async () => {
    try {
      const payLoad = {
        companyId: localStorage.getItem("companyId") || companyId,
      };
      const response = await post(
        apiEndpoints.getAllLocationsByCompany,
        payLoad
      );
      if (response.status === 200) {
        setLocationsDropdown(response?.data);
      }
      const companyDevices = await get(apiEndpoints.getAllMachineTypes);
      if (companyDevices.status === 200) {
        setMachineTypesDropdown(companyDevices?.data);
      }
      const responseC = await get(apiEndpoints.getAllCompanies);
      if (responseC && responseC.status === 200 && responseC.data) {
        setCompanyDropdown(responseC.data);
      }
    } catch (error) {
      console.log(error);
      message.error("Error while fetching");
    }
  };

  const onFinish = async (values: any) => {
    try {
      // const modifiedValues = {
      //   ...values,
      //   active: values.active ? 1 : 0,
      // };

      // Now use modifiedValues for submission
      console.log("Form Submit", values);
      const payLoad: any = { ...values, companyMasterId: values?.companyId };
      setIsLoading(true);
      const endPoints = {
        updateDevice: "updateMachineMaster",
        addDevice: "addMachineMaster",
      };
      const endPoint: any = id ? endPoints.updateDevice : endPoints.addDevice;
      const method = id ? put : post;
      const response: any = await method(apiEndpoints[`${endPoint}`], payLoad);
      if (response.status === 200) {
        notification.success({
          message: id ? "Updated Successfully" : "Created Successfully",
        });
        navigate("/machines");
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsLoading(false);
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
    message.error("Please fill in all fields");
  };

  const paymentModeDropdown = [
    { id: 0, value: "Regular with Payment" },
    { id: 1, value: "Skip Payment" },
  ];

  const eventControlDropdown = [
    { id: 0, value: "off-stop" },
    { id: 1, value: "can dispense" },
  ];

  const companyFormMeta: any = [
    {
      name: "companyId",
      label: "Company Name",
      type: "select",
      placeholder: "Select Company Name",
      rules: [{ required: true, message: "Select a Company Name!" }],
      widget: Select,
      onchange: (value: any) => {
        console.log(value, "value---");
      },
      widgetProps: {
        options: companyDropdown.map((c: any) => ({
          value: c.companyId,
          label: c.companyName,
        })),
      },
    },
    {
      name: "machineName",
      label: "Name",
      type: "input",
      placeholder: "Enter Machine Name",
      rules: [
        { required: true, message: "This field is required" },
        { min: 4, message: "Name must be at least 4 characters" },
      ],
    },
    {
      name: "machineAddress",
      label: "Address",
      type: "input",
      placeholder: "Enter Machine Address",
      widgetProps: {
        maxLength: 16,
      },
      rules: [
        { required: true, message: "This field is required" },
        // {
        //   pattern: "^[0-9a-fA-F]*$",
        //   message: "Only A to F and 0 to 9 are allowed",
        // },
      ],
    },
    {
      name: "locationId",
      label: "Location",
      type: "select",
      placeholder: "Select Location",
      rules: [{ required: true, message: "Select a Location!" }],
      // options: [],
      widget: Select,
      widgetProps: {
        options: locationsDropdown.map((c: any) => ({
          value: c.locationId,
          label: c.locationName,
        })),
      },
    },
    {
      name: "machineTypeId",
      label: "Type",
      type: "select",
      placeholder: "Select Type",
      rules: [{ required: true, message: "Select a Type!" }],
      // options: [],
      widget: Select,
      widgetProps: {
        options: machineTypesDropdown.map((c: any) => ({
          value: c.machine_type_id,
          label: c.machineTypeName,
        })),
      },
    },
    {
      name: "machine_mode",
      label: "Machine Mode",
      type: "select",
      placeholder: "Select Machine Mode",
      rules: [{ required: true, message: "Select a Machine Mode!" }],
      // options: [],
      widget: Select,
      widgetProps: {
        options: paymentModeDropdown.map((c: any) => ({
          value: c.id,
          label: c.value,
        })),
      },
    },
    {
      name: "event_control",
      label: "Event Control",
      type: "select",
      placeholder: "Select Event Control",
      rules: [{ required: true, message: "Select a Event Control!" }],
      // options: [],
      widget: Select,
      widgetProps: {
        options: eventControlDropdown.map((c: any) => ({
          value: c.id,
          label: c.value,
        })),
      },
    },
  ];

  return (
    <>
      <div
        className="filters"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Form
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          initialValues={
            {
              /* Set initial values if any */
            }
          }
          className="company-form"
        >
          {/* <FormBuilder meta={companyFormMeta} form={form} /> */}
          <Row gutter={24}>
            {companyFormMeta.map((item: any, index: any) => (
              <Col span={8} key={index}>
                <FormBuilder meta={[item]} form={form} />
              </Col>
            ))}
          </Row>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isLoading}
              style={{ marginRight: "10px" }}
            >
              {id ? "Update Machine" : "Add Machine"}
            </Button>
            <Button onClick={() => navigate("/machines")}>Cancel</Button>
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

export default MachinesForm;
